import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'news_edition';

const EditionContext = createContext({
  edition: 'global',
  setEdition: () => {},
});

export function EditionProvider({ children }) {
  const [edition, setEditionState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'global';
    } catch {
      return 'global';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, edition);
    } catch {
      /* ignore */
    }
  }, [edition]);

  const setEdition = useCallback((value) => {
    setEditionState(value || 'global');
  }, []);

  return (
    <EditionContext.Provider value={{ edition, setEdition }}>
      {children}
    </EditionContext.Provider>
  );
}

export function useEdition() {
  return useContext(EditionContext);
}
